import { render, staticRenderFns } from "./MenuOpcion.vue?vue&type=template&id=7dc0dc39&"
import script from "./MenuOpcion.vue?vue&type=script&lang=js&"
export * from "./MenuOpcion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports